import React, {useState, useEffect} from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";


export default function TextImage(props) {

	const height= window.innerHeight;  
	const width= window.innerWidth;

	useEffect(() => {
		const height= window.innerHeight;
		const width= window.innerWidth;
	}, []);

	if (props.isMobile) {
		return (
        <TransformWrapper>
            <TransformComponent>
			<div
				style={{
					position: "relative",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor: "black",
				}}
			>
				<img
					src={props.src}
					width = "95%"
					alt="description of image"
				>
				</img>
			</div>
            </TransformComponent>
    </TransformWrapper>
		)
	} else {
		return (
			<div
				style={{
					position: "relative",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor: "black",
					opacity: props.src? "1" : "0",
				}}
			>
				<img
						src={props.src}
						height= {0.7*height}
						alt="description of image"
						 >
				</img>
			</div>  
		)
	}
}